import React from 'react';
import { Helmet } from 'react-helmet-async';
import { SEOProps } from '../types/seo';

const SEO: React.FC<SEOProps> = ({
  data,
  canonicalUrl,
  noindex = false,
  nofollow = false
}) => {
  const {
    title,
    description,
    keywords,
    imageUrl,
  } = data;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />

      {/* Robots Meta */}
      {noindex && <meta name="robots" content="noindex" />}
      {nofollow && <meta name="robots" content="nofollow" />}
      {!noindex && !nofollow && <meta name="robots" content="index, follow" />}

      {/* Canonical URL */}
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}

      {/* Open Graph Meta Tags */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={imageUrl} />
      <meta property="og:image:alt" content={title} />
      {canonicalUrl && <meta property="og:url" content={canonicalUrl} />}
      <meta property="og:site_name" content="gimmefy" />

      {/* Twitter Meta Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@gimmefy" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={imageUrl} />
      <meta name="twitter:image:alt" content={title} />

      {/* Additional Meta Tags */}
      <meta name="author" content="gimmefy" />
      <meta name="viewport" content="width=device-width, initial-scale=1" />

      {/* Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Organization",
          "name": "gimmefy",
          "url": "https://gimmefy.ai",
          "logo": "https://gimmefy.ai/server-assets/images/gimmefy-logo.png",
          "description": description,
          "sameAs": [
            "https://twitter.com/gimmefy",
            "https://linkedin.com/company/gimmefy"
          ]
        })}
      </script>
    </Helmet>
  );
};

export default SEO;